import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormCotacaoVeiculosComponent } from './form-cotacao-veiculos.component';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import {
  TermsOfAcceptanceModule
} from '../terms-of-acceptance/terms-of-acceptance.module';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
    declarations: [FormCotacaoVeiculosComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(options),
    TermsOfAcceptanceModule,
  ],
    exports: [
        FormCotacaoVeiculosComponent
    ]
})
export class FormCotacaoVeiculosModule { }
